import React, { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Stepper from "./stepper"
import axios from "axios"
import Spinner from "../spinner"
import { ToastContainer, toast } from 'react-toastify'
import configData from "../../config.json"
import { motion } from "framer-motion"
import { UilSearch } from '@iconscout/react-unicons'

function Identification() {
  const [name, setName] = useState('')
  const [data, setData] = useState([])
  const [inputId, setInputId] = useState('')
  const [continueStep, setContinueStep] = useState(false)
  const [loading, setLoading] = useState(false)


  const getInfo = async (event) => {
    try {
      console.log(inputId)
      if(inputId !== ''){
        setLoading(true)
        const response = await axios.get(`${configData.API_URL}/data/getLeadInfo/` + inputId, {
          headers: {
            'Access-Control-Allow-Origin': '*', // replace * with the API server domain
            'Content-Type': 'application/json'
          }
        })

        let data = response.data.result
        setData(data)
        localStorage.setItem('info', JSON.stringify(data))
        let name = data.name + ' ' + data.firstName + ' ' + data.secondName
        validateStudent(inputId).then(response => {
          if (response.estado == '1') {
            setContinueStep(false)

            toast.info(response.descripcion, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });

            setLoading(false)
          }
          else
            setContinueStep(true)
          setLoading(false)
        })

        setName(name)
      }else{
        toast.warning('Por favor complete la informacion requerida', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      
    } catch (error) {
      setLoading(false)
      console.log(error)
      toast.error('Ha ocurrido un error, por favor valide que la identificación cuente con el formato correcto', {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
    }
  }

  function validateStudent(personId) {
    try {
      var info = []
      setLoading(true)
      return axios.get(`${configData.API_URL}/data/isStudent/` + personId)
        .then(function (response) {
          return response.data.result
        })
    } catch (error) {
      console.log(error)
      return []
    }
  }


  const handleInput = (event) => {
    setInputId(event.target.value)
  };



  return (
    <motion.main
      className="main__container"
      initial={{ width: 0 }}
      animate={{ width: "100%" }}
      exit={{ x: "100%", opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div>
        <Stepper step="1"></Stepper>
        <section className="text-center container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
          />
          {/* Same as */}
          <ToastContainer />
          <Spinner show={loading} ></Spinner>

          <div className="row">
            <div className="offset-lg-4 col-lg-4 mb-4 col-sm-12 pt-5">
              <h1>Digitá tu número de identidad </h1>
            </div>
            <div className="offset-lg-4 col-lg-4 mb-4 col-sm-12">
              <div className="mb-3">
                <label className="form-label">Ingresá los  9 dígitos de tu cédula</label>
                <div class="input-group">
                  <input type="text" class="form-control" value={inputId} onChange={handleInput} maxLength={9}/>
                  <div class="input-group-append">
                    <button class="btn btn-secondary" type="button" onClick={getInfo}>
                      <UilSearch />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row pt-2 pb-2">
            <div className="col-12">
              <h2>{name}</h2>
            </div>
          </div>
          <div className="row pt-2 pb-5">
            <div className="pt-2 offset-lg-3 col-lg-3 col-md-12 col-sm-12 text-center">
              <Link className="btn btn-lg w-100 btn-red" to="/information">Regresar</Link>
            </div>
            <div className="pt-2 col-lg-3 col-sm-12 text-center">
              <Link className={`btn btn-lg w-100 btn-yellow ${!continueStep ? "disabled" : ""}`} to="/information/complete" disabled={continueStep}>Continuar</Link>
            </div>
          </div>
        </section>
      </div>
    </motion.main>
  )
}

export default Identification